const BASE = {
	BASE_URL: '/',
	SHOPIFY_COOKIE_EXPIRE: 90,
	SHOPIFY_API_VERSION: '2023-10',
	APP_SHORT_NAME: 'RMK_GIFTCARD',
	APP_NAME: "Rumi's Kitchen Gift Card",

	//* Parse
	Parse: {
		appId: '<appID>',
		//exp: 'myAppId',

		serverURL: '<serverURL>',
		//exp: 'https://back.test.com/parse'

		liveQueryServerURL: '<liveQueryServerURL>',
		//exp: 'wss://back.test.com'
	},
};

const SERVER = process.env.REACT_APP_SERVER || '';
const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_DOMAIN || '';
const SHOPIFY_STOREFRONT_API_ACCESS_TOKEN =
	process.env.REACT_APP_SHOPIFY_STOREFRONT_API_ACCESS_TOKEN || '';

export type CONFIG_TYPE = typeof BASE & {
	SERVER: string;
	SHOPIFY_DOMAIN: string;
	SHOPIFY_STOREFRONT_API_ACCESS_TOKEN: string;
	API_SERVER: string;
};

export const CONFIG: CONFIG_TYPE = {
	...BASE,
	SERVER,
	SHOPIFY_DOMAIN,
	SHOPIFY_STOREFRONT_API_ACCESS_TOKEN,
	API_SERVER: SERVER + '/api',
};

window.CONFIG = CONFIG;
